module.exports = __webpack_public_path__ + "media/images/icons/filled/thunderbolt-59169fb11369ff9551050c6cef348375.svg";